export class DatePickerMonth {
    
    text: string;
    class: string; 
    constructor (text,clas) {
        this.text = text;
        this.class= clas; 
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/datepicker/data-picker-month.ts